
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tools/affiliate-links",
      function () {
        return require("private-next-pages/[locale]/tools/affiliate-links/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tools/affiliate-links"])
      });
    }
  